import React, { useEffect, useState } from 'react';
import { LocationPermission } from './components/LocationPermission';
import { StoreLocations } from './components/StoreLocations';
import { useGeolocated } from 'react-geolocated';
import { ShopPage } from './ShopPage';
import Section from '~/shared/Section';
import { ShopStoreBottomSheet } from './components/StoreBottomSheet';
import {
    useRetailersQuery,
    useDutchieStore,
    useCreateCheckoutMutation,
    useI18n
} from '@springbig/shared';
import Loading from '~/shared/Loading';
import { VStack, HStack, Modal, Pressable } from 'native-base';
import { SpIcon } from '~/shared/Icon';
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons';
import { useShopStyles } from '~/shared/styles';
import { Caption, H3 } from '~/shared/Typography';

export const Shop = () => {

    const { t } = useI18n();
    const [showOrderSubmittedModal, setShowOrderSubmittedModal] = useState(false);
    const [selectedDistance, setSelectedDistance] = useState<number>(30);
    const distances = [30, 50, 100];
    const {
        retailer,
        setRetailer,
        setMenuType,
        menuType,
        fullfillmentOption,
        setCheckout,
        showStoreBottomSheet,
        setShowStoreBottomSheet,
        setFullfillmentOption
    } = useDutchieStore();
    const { mutate: getRetailers, data, isLoading } = useRetailersQuery();
    const { primary_color, icon, pressable_text, button_background, button_text, section_background } = useShopStyles();
    const { mutate: createCheckout, data: newCheckout } = useCreateCheckoutMutation();

    const { isGeolocationAvailable, coords, isGeolocationEnabled } =
        useGeolocated({
            positionOptions: {
                enableHighAccuracy: true,
            },
        });

    useEffect(() => {

        if (isGeolocationEnabled && coords) {
            const variables = {
                'latitude': coords.latitude,
                'longitude': coords.longitude,
                'maxDistance': selectedDistance,
                'unit': 'MI',
            };
            getRetailers(variables);
        }
    }, [isGeolocationEnabled, coords, getRetailers, selectedDistance]);

    useEffect(() => {

        if (newCheckout) {
            setCheckout(newCheckout.createCheckout);
        }

        setShowStoreBottomSheet(false);
    }, [newCheckout]);

    useEffect(() => {

        const urlParams = new URLSearchParams(window.location.search);
        const orderNumber = urlParams.get('orderNumber');
        if (orderNumber) {
            setShowOrderSubmittedModal(true);
            createCheckout({
                pricingType: menuType,
                orderType: fullfillmentOption?.key,
                retailerId: retailer?.id,
            });
        }
    }, [window.location.search]);

    const body = () => {

        if (!isGeolocationEnabled || !isGeolocationAvailable) {
            return <LocationPermission />;
        }
        else if (!retailer) {
            return (
                <Section>
                    { isLoading ?
                        <VStack h={'100%'}>
                            <Loading my={'auto'} isLoading={isLoading} />
                        </VStack>
                        :
                        <VStack py={4} bg={primary_color}>
                            <VStack alignItems={'center'} space={4}>
                                <H3>{ t('shop.distance') }</H3>
                                <HStack space={4}>
                                    { distances.map((distance, index) =>

                                        <Pressable
                                            key={index}
                                            onPress={() => setSelectedDistance(distance)}
                                            rounded={'sm'}
                                            px={2}
                                        >
                                            <Caption
                                                color={selectedDistance === distance && pressable_text}
                                            >
                                                { distance } miles
                                            </Caption>
                                        </Pressable>
                                    )}
                                </HStack>
                            </VStack>
                            {data && data.retailersNearLocation.length !== 0 ? <StoreLocations
                                setMenuType={setMenuType}
                                setRetailer={setRetailer}
                                stores={data.retailersNearLocation}
                                t={t}
                                setFullfillmentOption={(value) => setFullfillmentOption(value)}
                            /> : <Caption textAlign={'center'} py={2}>Shopping is Not Avaliable in your current location</Caption>}
                        </VStack>
                    }
                </Section>
            );
        }
        else if (retailer) {
            return <ShopPage />;
        }
    };

    return (
        <>
            { body() }
            <ShopStoreBottomSheet
                isOpen={showStoreBottomSheet}
                onClose={() => setShowStoreBottomSheet(!showStoreBottomSheet)}
            />
            { showOrderSubmittedModal &&
                <Modal isOpen={showOrderSubmittedModal}>
                    <Modal.Content>
                        <Modal.CloseButton onPress={() => setShowOrderSubmittedModal(false)} />
                        <Modal.Body>
                            <VStack alignItems={'center'} py={4}>
                                <SpIcon icon={faShoppingBag} color={icon} size={72}/>
                                <Caption color={pressable_text} fontSize={24}>{ t('shop.order_submitted') }</Caption>
                            </VStack>
                        </Modal.Body>
                    </Modal.Content>
                </Modal>
            }
        </>
    );
};

